import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

import { cn, focusRing } from "../../../../components/ui";

// Report 58: one way to point from a setting to the screen where the related work is done — a verb and the
// destination, the same size and place everywhere ("Manage employee schedules"), never an "Open HR › …" breadcrumb.
const linkClass = cn(
  "inline-flex items-center gap-1 rounded-control text-body-sm font-medium text-accent hover:underline max-md:min-h-touch",
  focusRing,
);

export function SettingsRelatedLink({ to, children }) {
  return (
    <Link to={to} className={linkClass}>
      {children}
      <ArrowUpRight aria-hidden="true" className="h-3.5 w-3.5" />
    </Link>
  );
}

/** A short list of related destinations at the foot of a settings section. */
export default function SettingsRelatedLinks({ items = [], label = "Related" }) {
  const shown = items.filter(Boolean);
  if (!shown.length) return null;
  return (
    <nav aria-label={label} className="mt-4 border-t border-subtle pt-3">
      <ul className="flex flex-col gap-1 sm:flex-row sm:flex-wrap sm:gap-x-5">
        {shown.map((item) => (
          <li key={item.to}><SettingsRelatedLink to={item.to}>{item.label}</SettingsRelatedLink></li>
        ))}
      </ul>
    </nav>
  );
}
